// extracted by mini-css-extract-plugin
module.exports = {"container":"death-notice-images-module--container--2YWlC","image":"death-notice-images-module--image--uOZ84"};